import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";

type MissingQuestionnaireProps = {
    label: string;
};
export const MissingQuestionnaire = (props: MissingQuestionnaireProps) => {
    const theme = useTheme();

    return (
        <WhiteBox>
            <Stack
                paddingBlock={theme.spacing(8)}
                justifyContent={"center"}
                alignItems={"center"}
                gap={theme.spacing(4)}
            >
                <FoodsIllustrations illustration="notEnoughData" />
                <Typography variant="body-bold">{props.label}</Typography>
            </Stack>
        </WhiteBox>
    );
};
